<template>
  <div>
    <section class="pt-4 mb-4">
      <div class="container text-center">
        <div class="row">
          <div class="col-lg-6 text-center text-lg-left">
            <h1 class="fw-600 h4">{{ $t("对比") }}</h1>
          </div>
          <div class="col-lg-6">
            <ul
              class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end"
            >
              <li class="breadcrumb-item opacity-50">
                <a
                  class="text-reset"
                  href="javascript:void(0)"
                  @click="goto('/')"
                  >{{ $t("首页") }}</a
                >
              </li>
              <li class="text-dark fw-600 breadcrumb-item">
                <a class="text-reset" href="javascript:void(0)">{{
                  $t("对比")
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-4">
      <div class="container text-left">
        <div class="bg-white shadow-sm rounded">
          <div
            class="p-3 border-bottom d-flex justify-content-between align-items-center"
          >
            <div class="fs-15 fw-600">{{ $t("对比") }}</div>
            <a
              class="btn btn-soft-primary btn-sm fw-600"
              href="javascript:void(0)"
              style="text-decoration: none"
              @click="reset"
            >
              {{ $t("重置对比列表") }}
            </a>
          </div>
          <div v-if="list.length" class="p-3">
            <table class="table table-responsive table-bordered mb-0">
              <thead>
                <tr>
                  <th class="font-weight-bold" scope="col">
                    {{ $t("商品名") }}
                  </th>
                  <td
                    v-for="item in list"
                    :key="item.id"
                    class="font-weight-bold"
                    scope="col"
                  >
                    <a
                      class="text-reset fs-15 line-2"
                      href="#"
                      @click="
                        jump(
                          `/product?goodsId=${item.goodsId}&shopId=${item.shopId}`
                        )
                      "
                      >{{ $t(item.goodsName) }}</a
                    >
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">{{ $t("图片") }}</th>
                  <td v-for="item in list" :key="item.id">
                    <img
                      :src="getFileViewUrl(item.goodsPic)"
                      alt
                      class="img-fit2 py-4 w-100px h-md-210px"
                      loading="lazy"
                    />
                  </td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("价格") }}</th>
                  <td v-for="item in list" :key="item.id">
                    <span class="fw-700 text-primary">{{
                      formatMoney(item.goodsPrice)
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("品牌") }}</th>
                  <td v-for="item in list" :key="item.id">
                    {{ $t("没有品牌") }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("类别") }}</th>
                  <td v-for="item in list" :key="item.id">
                    {{ $t(item.goodsCateName) }}
                  </td>
                </tr>
                <tr>
                  <th scope="row"></th>
                  <td
                    v-for="item in list"
                    :key="item.id"
                    class="text-center py-4"
                  >
                    <button
                      class="btn btn-primary fw-600"
                      type="button"
                      @click="addToCart(item)"
                    >
                      {{ $t("添加到购物车") }}
                    </button>
                    <button
                      class="btn btn-sm btn-icon stop-propagation"
                      type="button"
                      @click="removeFromCompareList(item.id)"
                    >
                      <i class="la la-close"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center p-4">
            <p class="fs-17">{{ $t("您的对比列表为空") }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  computed: {
    list() {
      return this.$store.state.user.compareList;
    }
  },
  methods: {
    reset() {
      this.$store.dispatch("user/deleteAllFromCompareList");
    },
    removeFromCompareList(id) {
      this.$store.dispatch("user/deleteFromCompareList", id);
    },
    addToCart(item) {
      this.gotToProduct(item.goodsId, item.shopId);
    }
  }
};
</script>
